import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
// import Swal from "sweetalert2"; // Remove SweetAlert
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BASE_URL from "../config";

import $ from "jquery";
import "jquery-validation";
const EditUser = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get("id"); // Get ID from URL query string

    const [formData, setFormData] = useState({
        username: "",
        email: "",
        personal_email: "",
        password: "",
        phone: "",
        address: "",
        bio: "",
        image_url: "",
        role: "",
        status: "active",
        emergency_phone: "",
        emergency_person_name: "",
        emergency_person_relation: "",
        facebook_link: "",
        resign_date: "",
        linkedIn_link: "",
    });

    // Fetch user data with payments
    useEffect(() => {
        const token = localStorage.getItem("token");
        if (id) {
            fetch(`${BASE_URL}api/user/find-one/${id}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                }
            })
                .then(response => response.json())
                .then(data => {
                    console.log(data);
                    if (data) {
                        setFormData({
                            username: data.username || "",
                            email: data.email || "",
                            personal_email: data.personal_email || "",
                            password: data.password || "",
                            phone: data.phone || "",
                            address: data.address || "",
                            bio: data.bio || "",
                            image_url: data.image_url || "",
                            role: data.role || "",
                            status: data.status || "active",
                            emergency_phone: data.emergency_phone || "",
                            emergency_person_name: data.emergency_person_name || "",
                            emergency_person_relation: data.emergency_person_relation || "",
                            facebook_link: data.facebook_link || "",
                            resign_date: data.resign_date || "",
                            linkedIn_link: data.linkedIn_link || ""

                        });
                    }
                })
                .catch(error => {
                    console.error("Error fetching User data:", error);
                    toast.error("Failed to fetch User data.");
                });
        }
    }, [id]);

    // jQuery Validation Setup
    useEffect(() => {
        $("#editUserForm").validate({
            rules: {
                username: "required",
                bio: "required",
                facebook_link: "required",
                linkedIn_link: "required",
                image_url: "required",
                email: {
                    required: true,
                    email: true
                },
                personal_email: {
                    required: true,
                    email: true
                },
                phone: {
                    required: true,
                    digits: true,
                    minlength: 10,
                    maxlength: 12
                },
                address: "required",
                emergency_phone: {
                    required: true,
                    digits: true,
                    minlength: 10,
                    maxlength: 12
                },

                emergency_person_name: "required",
                emergency_person_relation: "required",
            },
            messages: {
                username: "Please enter a name",
                bio: "Please enter a bio",
                facebook_link: "Please enter a Facebook Link",
                linkedIn_link: "Please enter a LinkedIn Link",
                image_url: "Please enter a Profile URL",
                email: {
                    required: "Please enter an email",
                    email: "Enter a valid email"
                },
                personal_email: {
                    required: "Please enter a personal email",
                    email: "Enter a valid email"
                },
                phone: {
                    required: "Please enter a phone number",
                    digits: "Only numbers allowed",
                    minlength: "Must be at least 10 digits",
                    maxlength: "Cannot exceed 12 digits"
                },
                address: "Please enter an address",
                emergency_phone: {
                    digits: "Only numbers allowed",
                    minlength: "Must be at least 10 digits",
                    maxlength: "Cannot exceed 12 digits"
                },
                emergency_person_name: "Please enter emergency contact name",
                emergency_person_relation: "Please enter emergency contact relation",
            },
            errorClass: "text-danger",
            submitHandler: function(form) {
                handleSubmit(); // Call without event argument
            }
        });
    }, []);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = () => {
        // Remove password from payload if not being updated
        const { password, ...updateData } = formData;
        Object.keys(updateData).forEach(
            key => (updateData[key] === undefined || updateData[key] === null || updateData[key] === "") && delete updateData[key]
        );
        const token = localStorage.getItem("token");
        // Log payload for debugging
        console.log("Submitting updateData:", updateData);
        fetch(`${BASE_URL}api/user/update-user/${id}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
            body: JSON.stringify(updateData)
        })
            .then(async response => {
                console.log("Response status:", response.status);
                if (!response.ok) {
                    let errMsg = "Failed to update User data";
                    try {
                        const errData = await response.json();
                        console.log("Backend error response:", errData);
                        if (errData && errData.error) errMsg = errData.error;
                        if (errData && errData.message) errMsg = errData.message;
                    } catch (err) {
                        console.log("Error parsing backend error response:", err);
                    }
                    throw new Error(errMsg);
                }
                return response.json();
            })
            .then(data => {
                console.log("Updated User Data:", data);
                toast.success("User Updated Successfully!");
                setTimeout(() => {
                    window.location.href = "/Users";
                }, 1200);
            })
            .catch(error => {
                console.error("Error updating User data:", error);
                toast.error(error.message || "Failed to update User data.");
            });
    };


    return (
        <div className="Users mt-4 mx-3">
            <h2 className="mb-3">Edit User</h2>
            <form id="editUserForm" onSubmit={handleSubmit}>
                <div className="row mb-3">
                    <div className="col-md-6">
                        <label className="form-label">Name</label>
                        <input type="text" className="form-control" name="username" value={formData.username} onChange={handleChange} required />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Email</label>
                        <input type="text" className="form-control" name="email" value={formData.email} onChange={handleChange} required />
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-md-6">
                        <label className="form-label">Personal Email</label>
                        <input type="text" className="form-control" name="personal_email" value={formData.personal_email} onChange={handleChange} required />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Phone</label>
                        <input type="text" className="form-control" name="phone" value={formData.phone} onChange={handleChange} />
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-md-6">
                        <label className="form-label">Address</label>
                        <input type="text" className="form-control" name="address" value={formData.address} onChange={handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Bio</label>
                        <textarea className="form-control" name="bio" value={formData.bio} onChange={handleChange}></textarea>
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-md-6">
                        <label className="form-label">Profile Image URL</label>
                        <input type="text" className="form-control" name="image_url" value={formData.image_url} onChange={handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Role</label>
                        <select className="form-control" name="role" value={formData.role} onChange={handleChange}>
                            <option value="user">User</option>
                            <option value="admin">Admin</option>
                        </select>
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-md-6">
                        <label className="form-label">Status</label>
                        <select className="form-control" name="status" value={formData.status} onChange={handleChange}>
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                        </select>
                    </div>
                    <div className="col-md-6 ">
                        <label className="form-label">Resign Date</label>
                        <input
                            type="date"
                            className="form-control"
                            name="resign_date"
                            value={formData.resign_date}
                            onChange={handleChange}
                        />
                    </div>

                </div>

                <h5>Emergency Contact</h5>
                <div className="row mb-3">
                    <div className="col-md-6">
                        <label className="form-label">Emergency Phone</label>
                        <input type="text" className="form-control" name="emergency_phone" value={formData.emergency_phone} onChange={handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Emergency Contact Name</label>
                        <input type="text" className="form-control" name="emergency_person_name" value={formData.emergency_person_name} onChange={handleChange} />
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-md-6">
                        <label className="form-label">Emergency Contact Relation</label>
                        <input type="text" className="form-control" name="emergency_person_relation" value={formData.emergency_person_relation} onChange={handleChange} />
                    </div>
                </div>

                <h5>Social Media Links</h5>
                <div className="row mb-3">
                    <div className="col-md-6">
                        <label className="form-label">Facebook</label>
                        <input type="text" className="form-control" name="facebook_link" value={formData.facebook_link} onChange={handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">LinkedIn</label>
                        <input type="text" className="form-control" name="linkedIn_link" value={formData.linkedIn_link} onChange={handleChange} />
                    </div>
                </div>

                <button type="submit" className="btn btn-primary">Update User</button>
                <a href="/users" className="btn btn-secondary mx-3">Cancel</a>
            </form>
            <ToastContainer /> {/* Add ToastContainer for notifications */}
        </div>
    );
};

export default EditUser;